module.exports = __webpack_public_path__ + "img/solution-data-logo10.4652a6b1.png";